module.exports = __webpack_public_path__ + "img/以图搜图ico.54053239.png";